__turbopack_context__.v({
  "active": "multi-module-scss-module__JI1Xbq__active",
  "addedBagBtn": "multi-module-scss-module__JI1Xbq__addedBagBtn",
  "alocholBlock": "multi-module-scss-module__JI1Xbq__alocholBlock",
  "alocholModalBlock": "multi-module-scss-module__JI1Xbq__alocholModalBlock",
  "attribute-label": "multi-module-scss-module__JI1Xbq__attribute-label",
  "auctionBlock": "multi-module-scss-module__JI1Xbq__auctionBlock",
  "auctionImg": "multi-module-scss-module__JI1Xbq__auctionImg",
  "auctionProductName": "multi-module-scss-module__JI1Xbq__auctionProductName",
  "auctionTime": "multi-module-scss-module__JI1Xbq__auctionTime",
  "availShip": "multi-module-scss-module__JI1Xbq__availShip",
  "black-bt": "multi-module-scss-module__JI1Xbq__black-bt",
  "blackBt": "multi-module-scss-module__JI1Xbq__blackBt",
  "blockType": "multi-module-scss-module__JI1Xbq__blockType",
  "bottomWidth": "multi-module-scss-module__JI1Xbq__bottomWidth",
  "brandBlock": "multi-module-scss-module__JI1Xbq__brandBlock",
  "breadcums": "multi-module-scss-module__JI1Xbq__breadcums",
  "btnCustom": "multi-module-scss-module__JI1Xbq__btnCustom",
  "btnOrange": "multi-module-scss-module__JI1Xbq__btnOrange",
  "btntyperadio": "multi-module-scss-module__JI1Xbq__btntyperadio",
  "buyNowBlock": "multi-module-scss-module__JI1Xbq__buyNowBlock",
  "buyPriceBlock": "multi-module-scss-module__JI1Xbq__buyPriceBlock",
  "caroselImage": "multi-module-scss-module__JI1Xbq__caroselImage",
  "carouselThumb": "multi-module-scss-module__JI1Xbq__carouselThumb",
  "checkmark": "multi-module-scss-module__JI1Xbq__checkmark",
  "colourCheck": "multi-module-scss-module__JI1Xbq__colourCheck",
  "colourFilter": "multi-module-scss-module__JI1Xbq__colourFilter",
  "colourFilterHd": "multi-module-scss-module__JI1Xbq__colourFilterHd",
  "colourFilterList": "multi-module-scss-module__JI1Xbq__colourFilterList",
  "comapreBtn": "multi-module-scss-module__JI1Xbq__comapreBtn",
  "container": "multi-module-scss-module__JI1Xbq__container",
  "customSlider": "multi-module-scss-module__JI1Xbq__customSlider",
  "detailInfoBlock": "multi-module-scss-module__JI1Xbq__detailInfoBlock",
  "detailPageBlock": "multi-module-scss-module__JI1Xbq__detailPageBlock",
  "dropActionBlock": "multi-module-scss-module__JI1Xbq__dropActionBlock",
  "dropActionBlockLeft": "multi-module-scss-module__JI1Xbq__dropActionBlockLeft",
  "dropActionText": "multi-module-scss-module__JI1Xbq__dropActionText",
  "flex": "multi-module-scss-module__JI1Xbq__flex",
  "formGroup": "multi-module-scss-module__JI1Xbq__formGroup",
  "formGroupControl": "multi-module-scss-module__JI1Xbq__formGroupControl",
  "formHeading": "multi-module-scss-module__JI1Xbq__formHeading",
  "formHeadingImg": "multi-module-scss-module__JI1Xbq__formHeadingImg",
  "formHeadingText": "multi-module-scss-module__JI1Xbq__formHeadingText",
  "freeShipping": "multi-module-scss-module__JI1Xbq__freeShipping",
  "freeShippingBanner": "multi-module-scss-module__JI1Xbq__freeShippingBanner",
  "fullBorderBottom": "multi-module-scss-module__JI1Xbq__fullBorderBottom",
  "heartButton": "multi-module-scss-module__JI1Xbq__heartButton",
  "heartIcon": "multi-module-scss-module__JI1Xbq__heartIcon",
  "infoTextStore": "multi-module-scss-module__JI1Xbq__infoTextStore",
  "labelName": "multi-module-scss-module__JI1Xbq__labelName",
  "leftAlign": "multi-module-scss-module__JI1Xbq__leftAlign",
  "licenseNumber": "multi-module-scss-module__JI1Xbq__licenseNumber",
  "message": "multi-module-scss-module__JI1Xbq__message",
  "modalHeading": "multi-module-scss-module__JI1Xbq__modalHeading",
  "moneyIcon": "multi-module-scss-module__JI1Xbq__moneyIcon",
  "outerSizeGuide": "multi-module-scss-module__JI1Xbq__outerSizeGuide",
  "owlThumbItem": "multi-module-scss-module__JI1Xbq__owlThumbItem",
  "pageHeading": "multi-module-scss-module__JI1Xbq__pageHeading",
  "priceBuy": "multi-module-scss-module__JI1Xbq__priceBuy",
  "priceBuyOuter": "multi-module-scss-module__JI1Xbq__priceBuyOuter",
  "productDetailInfo": "multi-module-scss-module__JI1Xbq__productDetailInfo",
  "productNameHeading": "multi-module-scss-module__JI1Xbq__productNameHeading",
  "productSlide": "multi-module-scss-module__JI1Xbq__productSlide",
  "productSlideThumb": "multi-module-scss-module__JI1Xbq__productSlideThumb",
  "productSliderBlock": "multi-module-scss-module__JI1Xbq__productSliderBlock",
  "promoList": "multi-module-scss-module__JI1Xbq__promoList",
  "promoListBorder": "multi-module-scss-module__JI1Xbq__promoListBorder",
  "removePaddingLeft": "multi-module-scss-module__JI1Xbq__removePaddingLeft",
  "removePaddingRight": "multi-module-scss-module__JI1Xbq__removePaddingRight",
  "retailerDonation": "multi-module-scss-module__JI1Xbq__retailerDonation",
  "sideBorder": "multi-module-scss-module__JI1Xbq__sideBorder",
  "sizeBlock": "multi-module-scss-module__JI1Xbq__sizeBlock",
  "sizeFilter": "multi-module-scss-module__JI1Xbq__sizeFilter",
  "sizeGuide": "multi-module-scss-module__JI1Xbq__sizeGuide",
  "sizeGuideIcon": "multi-module-scss-module__JI1Xbq__sizeGuideIcon",
  "sliderActions": "multi-module-scss-module__JI1Xbq__sliderActions",
  "socialSecRt": "multi-module-scss-module__JI1Xbq__socialSecRt",
  "swatch-type": "multi-module-scss-module__JI1Xbq__swatch-type",
  "textColor": "multi-module-scss-module__JI1Xbq__textColor",
  "textColorOne": "multi-module-scss-module__JI1Xbq__textColorOne",
  "textError": "multi-module-scss-module__JI1Xbq__textError",
  "viewPLink": "multi-module-scss-module__JI1Xbq__viewPLink",
});
